import {Inject, Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MenuBottomAddContentService {
    public menuChanged = new BehaviorSubject(false);

    constructor(private ngZone: NgZone) {

    }

    show() {
        this.menuChanged.next(true);
    }

    hide() {
        this.menuChanged.next(false);
    }

    toggle() {
        this.menuChanged.next(!this.menuChanged.value);
    }
}
